import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth';
import { Box, CircularProgress } from '@mui/material';

const AdminRoute = ({ children }) => {
    const { user, isAuthenticated, loading } = useAuth();

    if (loading) {
        return <Box display="flex" justifyContent="center" mt={10}><CircularProgress /></Box>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (user?.role !== 'admin') {
        // Not authorized
        return <Navigate to="/home" />;
    }

    return children;
};

export default AdminRoute;
